import { gql } from '@apollo/client';

export const ONBOARDING_TASK = gql`
  fragment OnboardingTaskFields on UserTask {
    id
    friendly_name
    description
    locked
    optional
    completed
  }
`;
